import { Component } from '@angular/core';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-rc-pro-medicale',
  standalone: true,
  imports: [PageLayoutComponent],
  templateUrl: './assurance-rc-pro-medicale.component.html',
  styleUrl: './assurance-rc-pro-medicale.component.scss'
})
export class AssuranceRcProMedicaleComponent {
  title = 'Assurance RC Pro Médicale';
  subtitle = 'Protection spécifique pour les professionnels de santé';
  heroImage = 'assets/images/hero-rc-medical.jpg';
  
  breadcrumbs = [
    { label: 'Professionnels', link: undefined },
    { label: 'RC Pro Médicale', link: undefined }
  ];

  prevPage = { title: 'RC Pro Générale', link: '/assurance-rc-pro-generale'
  };

  nextPage = { title: 'RC Pro Juridique', link: '/assurance-rc-pro-juridique'
  };
}
